import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuInserirComponent } from './menu-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: MenuInserirComponent }
    ])],
    exports: [RouterModule]
})
export class MenuInserirRoutingModule { }
